import React, { useEffect, useRef, useState } from "react"
import SVG from "react-inlinesvg";
import SimpleTable from "my-simple-react-table";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import * as handlers from "../../../../../_redux/selected-user/selectedUserHandlers";
import { errorMessage, formatAmount, formatDate, formatStatus } from "../../../../../../../util/Helpers";
import { toAbsoluteUrl } from "../../../../../../../../_metronic/_helpers";
import ViewLiquidationModal from "./modal/ViewLiquidationModal";
import DynamicSimpleTable from "../../../../../../../util/DynamicSimpleReactTable";
import cogoToast from "cogo-toast";

const Liquidations = props => {
    /* Get User Safe Locks from redux */
    const userEmail = useSelector(({ selectedUser }) => selectedUser.data.profile.basic.email, shallowEqual);
    const liquidations = useSelector(({ selectedUser }) => selectedUser.data?.liquidations, shallowEqual);
    const tableRef = useRef();

    /* Liquidations Modal State Management */
    const [liquidationsModal, setliquidationModal] = useState({ showViewLiquidationModal: false, details: null });

    // Redux dispatch
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(handlers.fetchUserLiquidations(userEmail))
            ;
    }, [dispatch, userEmail]);



    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setliquidationModal({ ...liquidationsModal, [modal]: !liquidationsModal[modal] })
    }


    // Action Butons
    const actionButton = row => {
        return <span style={{ whiteSpace: "nowrap" }}>
            <button
                className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                onClick={_ => viewLiquidationDetails(row.safeLockId)}
            >
                <span className="svg-icon svg-icon-md svg-icon-primary">
                    <SVG
                        title="View payment"
                        src={toAbsoluteUrl("/media/svg/icons/General/Eye-2.svg")}
                    />
                </span>
            </button>
        </span>
    }


    // View Liquidation Details
    const viewLiquidationDetails = safeLockId => {
        const details = liquidations.responseData.filter(liquidation => safeLockId === liquidation.safeLockId)[0];
        setliquidationModal({ ...liquidationsModal, showViewLiquidationModal: true, details });
    }


    return <div className="card card-custom gutter-b">
        <div className="row">
            <div className="col-12">
                {/* <!--begin::List Widget 14--> */}
                <div className="card card-custom gutter-b">
                    {/* <!--begin::Header--> */}
                    <div className="card-header border-0">
                        {/* <!--begin::Title--> */}
                        <div className="card-title pt-5 w-100">
                            <h3 className="card-label">
                                <span className="d-block text-dark h3 font-weight-bolder">Liquidations</span>
                                <span className="d-block text-muted mt-2 font-size-sm">User Liquidation Details</span>
                            </h3>
                        </div>
                    </div>
                    {/* <!--end::Header--> */}
                    {/* <!--begin::Body--> */}
                    <div className="card-body pt-0">
                        
                        <DynamicSimpleTable
                        searchBox={false}
                        source={{ url: `/users/liquidations/${userEmail}` }}
                        columns={[
                                             
                            { title: "Tenure", key: "tenor" },
                            { title: "Tenure Left", key: "tenorleftover" },
                            { title: "Customer Name", key: "customerName" },
                            { title: "Reference",  format: (row) => (row.safelockDeposits[0]
                                .tansactionId) }, 
                            {
                                title: "Maturity Date", format: (row) => formatDate(row.safelockDeposits[0]
                                    .maturityDate)
                            },
                            {
                                title: "Amount Locked", format: (row) => formatAmount(row.currency, row.safelockDeposits[0]
                                    .deposit)
                            },
                            { title: "Rate%", key: "rate" },
                            {
                                title: "Interest Earned", format: (row) => formatAmount(row.currency, row.safelockDeposits[0]
                                    .interestEarned)
                            },
                            {
                                title: "Payback Amount", format: (row) => formatAmount(row.currency, (row.safelockDeposits[0]
                                    .deposit) + ((row.currency, row.safelockDeposits[0]
                                        .interestEarned)))
                            },
                            {
                                title: "Date Created", format: (row) => formatDate(row.safelockDeposits[0]
                                    .createdAt)
                            },
                            {
                                title: "Payback Date", format: (row) => formatDate(row.safelockDeposits[0]
                                    .payBackDate)
                            },
                            {
                                title: "Status", format: (row) => formatStatus(row.safelockDeposits[0]
                                    .paymentStatus)
                            },
                            {title: "", format: actionButton}


                        ]}
                        ref={tableRef}
                        onError={(err) =>
                            cogoToast.error(errorMessage(err))
                        }
                        refreshIcon={true}
                    />
                        
                    </div>
                    {/* <!--end::Body--> */}
                </div>
                {/* <!--end::List Widget 14--> */}
            </div>
        </div>
        
        <ViewLiquidationModal {...liquidationsModal} onHide={toggleModal("showViewLiquidationModal")} />
    </div>
}
export default Liquidations;